import React from 'react'

interface GameProps {
  topic: {
    game?: {
      title: string
      description: string
      characters: Record<string, string>
      questions: { question: string; answer: string }[]
    }
  }
  showQuestions: boolean
  setShowQuestions: React.Dispatch<React.SetStateAction<boolean>>
  answerVisibility: Record<number, boolean>
  setAnswerVisibility: React.Dispatch<React.SetStateAction<Record<number, boolean>>>
}

const Game: React.FC<GameProps> = ({
  topic,
  showQuestions,
  setShowQuestions,
  answerVisibility,
  setAnswerVisibility
}) => {
  const { game } = topic

  if (!game) {
    return <p className='text-danger'>Game data not available.</p>
  }

  const toggleAnswerVisibility = (index: number) => {
    setAnswerVisibility((prevState) => ({
      ...prevState,
      [index]: !prevState[index]
    }))
  }

  return (
    <div className='card shadow-lg rounded-lg p-4 mb-4 no-wrap'>
      <div className='mt-4 mx-4'>
        {/* Title */}
        <div className='d-flex justify-content-between align-items-center'>
          <h3 className='text-primary font-weight-bold mb-0' style={{ fontSize: '2.5rem' }}>
            {game.title}
          </h3>
        </div>

        {/* Tabs for Overview and Questions */}
        <div className='d-flex justify-content-between mb-4 mt-4'>
          {/* <button
            className={`btn ${
              !showQuestions ? 'btn-primary' : 'btn-outline-primary'
            } btn-lg rounded-pill`}
            onClick={() => setShowQuestions(false)}
          >
            गेम ओवरव्यू
          </button> */}
          <button
            className={`btn ${
              showQuestions ? 'btn-success' : 'btn-outline-success'
            } btn-lg rounded-pill`}
            onClick={() => setShowQuestions(true)}
          >
            प्रश्न
          </button>
        </div>

        {/* Game Overview */}
        {!showQuestions ? (
          <>
            <p className='lead text-muted mb-4' style={{ fontSize: '1.8rem' }}>
              {game.description}
            </p>
            <div className='row'>
              {Object.entries(game.characters).map(([character, detail], index) => (
                <div key={index} className='col-md-4 mb-4'>
                  <div className='card h-100 shadow-sm'>
                    <div className='card-body text-center'>
                      <h5
                        className='card-title'
                        style={{
                          fontSize: '2rem',
                          fontWeight: 'bold',
                          color: '#007bff'
                        }}
                      >
                        {character}
                      </h5>
                      <p className='card-text' style={{ fontSize: '1.5rem', color: '#6c757d' }}>
                        {detail}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          // Game Questions
          <div className='mt-4'>
            <h4 className='text-success font-weight-bold mb-3' style={{ fontSize: '2.2rem' }}>
              प्रश्न
            </h4>
            {game.questions.map((item, index) => (
              <div key={index} className='mb-4'>
                <div className='d-flex justify-content-between align-items-center'>
                  <h5 className='text-muted' style={{ fontSize: '1.8rem', fontWeight: 'bold' }}>
                    प्रश्न {index + 1}: {item.question}
                  </h5>
                  <button
                    className='btn btn-info btn-sm rounded-pill'
                    onClick={() => toggleAnswerVisibility(index)}
                  >
                    {answerVisibility[index] ? 'उत्तर छुपाएं' : 'उत्तर देखें'}
                  </button>
                </div>
                {answerVisibility[index] && (
                  <div className='mt-3'>
                    <p className='text-muted' style={{ fontSize: '1.6rem' }}>
                      उत्तर: <span className='font-weight-bold'>{item.answer}</span>
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}

export default Game
